import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import FilterComp from "../../common/filter-comp.vue";
import DisplayTextData from "@/components/common/display-text-data.vue";
import ReadOnlyDialog from "@/components/common/read-only-dialog.vue";
import utility from "@/shared/utility";
import ChangeLpn from "../change-lpn-comp.vue";
import CommonDialog from "@/components/common/common-dialog.vue";
import RouteDiscrepancyComp from "../route-discrepancy-comp.vue";
import receiveService from "./receive-srvice";
import PrinterDetails from "@/components/common/printer-details.vue";
import UsbAssetResults from "../usb-asset-results.vue";
import usbReceiptState from "./usb-receipt-state";
import usbAssetStatusPolling from "./usb-asset-status-polling";

export default {
  mixins: [usbAssetStatusPolling],
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      lpnData: {},
      mainPage: "",
      subPage: "",
      backSlash: true,
      projectName: "",
      showPartInfo: false,
      partInfo: "",
      orderNum: "",
      ord_key: "",
      lableSwitchValue:true,
      showDiscrepancyDialog: false,
      disableStagingLoc:false,
      pageUrl: "",
      showAdd: false,
      failCount: 0,
      dispositionCallCount: 0,
      validatingSerial: false,
      pageNumber: 1,
      activeField: null,
      partDesc: "",
      searchType: "",
      partId: 0,
      showPrimary: true,
      printDisable: true,
      printerConfigured: false,
      serialNum: "",
      showTable: true,
      partList: [],
      showPartDDL: false,
      make: "",
      model: "",
      showMake: false,
      lpnObj: {},
      receiveType: "",
      showSerialData: false,
      showDialog: false,
      message: "",
      textSearch: "",
      showDetails: true,
      focusField:"waybill",
      showChangeLpn: false,
      required: [(v) => !!v || "Field is required"],
      inboundWaybill: "",
      waybillValidated: false,
      WayBillRule: [
        (v) => v?.length <= 25 || "Must be 25 characters or less",
        (v) => !!v || "Field is required",
      ],
      dialogType: "",
      partSearch: "",
      max50Rule: [
        (v) => (v || "").length <= 50 || "Max Length of 50 character",
      ],
      min3Rule: [
        (v) =>
          (v || "").length >= 3 || "Min Length must be 3 characters or More",
      ],
      pageCount: 0,

      showReceiveLPN: false,
      showReceiveStaging: false,
      showReceiveStagingVal: "",
      showAssestData: false,
      displayAssetData: [],
      dispositionResponse: null,
      assetInfoResponse: null,
      showLpnVal: "",
      labelValue: true,
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    this.receiveType = this.$route.path.replace("/", "")?.split("/")[1];
    let data = await AddFavourite.getPageAction(this.userId, "receiving");
    this.actionList = data.actionList;
    if (this.receiveType === "SO" || this.receiveType === "PO") {
      this.mainPage = "Receiving";
      this.favouriteList = data.favouriteList;
      this.pageUrl = "receiving";
      this.subPage = `${this.receiveType} Receiving`;
      this.deboundedPartList = utility.debounce(this.getPartList, 500);
      if (EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== null && EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== undefined) {
        this.labelValue = JSON.parse(EncryptUtility.localStorageDecrypt("LabelSwitchValue"));
        this.lableSwitchValue = this.labelValue;
      }
      this.onChangeLabelFunction(this.labelValue);
      if (this.lableSwitchValue) {
        if (EncryptUtility.localStorageDecrypt("primaryLabelSize") !== null && EncryptUtility.localStorageDecrypt("primaryLabelSize") !== undefined) {
          this.printDisable = false;
          this.printerConfigured = false;
        } else {
          this.printDisable = true;
          this.printerConfigured = true;
          let Alert = {
            type: "error",
            isShow: true,
            message: "Receiving/Inventory Printer is not configured, please configure printer",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      }
    }
  },
  computed: {},

  mounted() {
    const nextReceipt = usbReceiptState.nextReceipt;
    usbReceiptState.reset();
    this.lpnObj = JSON.parse(
      EncryptUtility.localStorageDecrypt("receivelpnDetails")
    );
    EncryptUtility.localStorageEncrypt("receiveDisplayAssest", "");
    EncryptUtility.localStorageEncrypt("receiveUsBankApiResults", "");
    if (this.lpnObj) {
      Object.assign(this, {
        showReceiveLPN: !!this.lpnObj.lpn,
        showLpnVal: this.lpnObj.lpn || "",
        showReceiveStaging: !!this.lpnObj.bin,
        showReceiveStagingVal: this.lpnObj.bin || "",
      });
      this.showDetails = true;
      this.displayArrayData = [
        { label: "Project", value: this.lpnObj.projectName },
        { label: "Warehouse Info", value: this.lpnObj.warehouseDetails },
      ];
      this.projectName = this.lpnObj.projectName;
      this.lpnObj.stockRoom == "AV9B"? this.disableStagingLoc=false : this.disableStagingLoc=true;
    }
    if (nextReceipt) {
      this.inboundWaybill = nextReceipt.waybill;
      this.waybillValidated = !!nextReceipt.waybill;
      this.focusField = nextReceipt.waybill ? "partSearch" : "waybill";
      EncryptUtility.localStorageEncrypt("receiveUsBankWaybill", nextReceipt.waybill);
      this.$nextTick(() => {
        const field = nextReceipt.waybill ? this.$refs.partNumberSearchField : this.$refs.waybillSearchField;
        field?.focus();
      });
    }
  },
  methods: {
    handleInput(fieldNumber) {
      let obj = "";
      obj =
        this.receiveType == "SO"
          ? this.soObj[fieldNumber]
          : this.poObj[fieldNumber];
      // If the field has a value, set it as active
      if (obj) {
        this.activeField = fieldNumber;
      } else {
        // If field is cleared, enable all fields
        this.activeField = null;
      }
    },
    isDisabled(fieldNumber) {
      // Disable if another field is active
      return this.activeField !== null && this.activeField !== fieldNumber;
    },
    actionSetter(permission) {
      return utility.actionSetter(this.actionList, permission);
    },
    onWaybillInput() {
      this.waybillValidated = false;
      this.clearPartSearch();
      EncryptUtility.localStorageEncrypt("receiveUsBankWaybill", "");
    },
    onWaybillEnter() {
      const isValid = this.$refs.waybillSearchField?.validate();
      if (!isValid) {
        this.focusField = "waybill";
        return;
      }
      this.inboundWaybill = this.inboundWaybill?.toUpperCase();
      this.waybillValidated = true;
      EncryptUtility.localStorageEncrypt("receiveUsBankWaybill", this.inboundWaybill);
      this.focusField = "partSearch";
    },
    clearWaybillSearch() {
      this.inboundWaybill = "";
      this.waybillValidated = false;
      this.focusField = "waybill";
      this.clearPartSearch();
      EncryptUtility.localStorageEncrypt("receiveUsBankWaybill", "");
      this.$refs.waybillSearchField?.resetValidation();
    },

    getPartData() {
      if (!this.waybillValidated) return;
      if (this.partSearch?.length > 2) {
        this.showPartDDL = true;
        this.deboundedPartList();
      } else {
        this.showPartDDL = false;
      }
    },
    async showPartItem(item) {
      if (!this.waybillValidated) {
        this.focusField = "waybill";
        return;
      }
      this.showPartDDL = false;
      this.dispositionCallCount = 0;
      this.showPartInfo = true;
      this.partSearch = item.part_num;
      this.partInfo = item.part_num;
      this.partDesc = item.found;
      this.partId = item.part_id;
      let partDetails = await receiveService.getPartDetails(
        "get",
        this.userId,
        item.part_id,
        false
      );
      partDetails.Result.PartInfo = partDetails.Result.PartInfo.map((part) => ({
        ...part,
        PartId: item.part_id,
      }));

      EncryptUtility.localStorageEncrypt(
        "receiveUsBankPartDetails",
        JSON.stringify(partDetails)
      );
      if (partDetails.Result.PartInfo[0].serial_bit) {
        this.showSerialData = true;
        this.focusField = "serialNum";
        this.$nextTick(() => {
          if (this.showSerialData) this.$refs.serialNumberField?.focus();
        });
      } else {
        this.redirectLineDetails();
      }
    },
    onChangeLabelFunction(value) {
      this.lableSwitchValue = value;
      EncryptUtility.localStorageEncrypt('LabelSwitchValue', JSON.stringify(this.lableSwitchValue));
    },
    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else {
        this.printDisable = true;
        this.printerConfigured = true;
      }
    },

    async getPartList() {
      this.partList = await receiveService.getPartListData(
        "get",
        this.userId,
        this.partSearch,
        false
      );
      if(this.partList.length==1 && this.partList[0].part_id==0){
      utility.showNoDataToast("No Data Available");
      this.showPartDDL=false;
      }
    },

    async onClickValidate() {
      if (this.validatingSerial) return;
      this.validatingSerial = true;
      try {
        await this.validateSerialDisposition();
      } finally {
        this.validatingSerial = false;
      }
    },
    async validateSerialDisposition() {
      this.stopAssetStatusPolling();
      const serialObj = {
        serialno: this.serialNum,
        IsReceipt: 1,
        UserId: this.userId,
      };

      if (!this.$refs.serialForm.validate()) return;

      const resp = await receiveService.postUsBankValidate(
        "post",
        serialObj,
        false
      );
      if (resp?.Info?.HeaderInfo[0]?.message !== "Success") return;

      this.showAssestData = false;
      this.dispositionResponse = null;
      this.assetInfoResponse = null;

      const externalObj = {
        serial_number: serialObj.serialno,
        receiving_sitecode: this.lpnObj.stockRoom,
        model_number: "",
        update_asset: false,
        create_unknown: false,
        model_description: "",
        po_number: "",
        tracking_number: this.inboundWaybill
      };
      usbReceiptState.reset();
      this.dispositionCallCount++;
      const externalRes = await receiveService.postUsBankGetDisposition(
        "post",
        externalObj,
        false
      );
      this.dispositionResponse = externalRes ?? null;
      let dispositionResult = null;
      try {
        dispositionResult = receiveService.getUsBankDispositionBody(externalRes);
      } catch {
        dispositionResult = null;
      }
      this.dispositionResponse = dispositionResult ?? externalRes ?? null;
      if (dispositionResult) {
        usbReceiptState.tracked = dispositionResult.model?.tracked === true
          || String(dispositionResult.model?.tracked).trim().toLowerCase() === "true";
        usbReceiptState.dispositionRequest = { ...externalObj };
      }
      if (dispositionResult) {
        this.displayAssetData = [
          { label: "Serial Number", value: externalObj.serial_number },
          { label: "Request Number", value: dispositionResult.reqNum },
          { label: "RITM", value: dispositionResult.RITM },
          { label: "Request Status", value: dispositionResult.reqStatus },
          { label: "Serial Number Status", value: "" },
          { label: "RLP Status", value: "" },
          { label: "Asset Action", value: "" },
          { label: "Disposition", value: dispositionResult.disposition },
        ];
        this.showAssestData = true;
      }
      const serialNotFound = dispositionResult?.disposition === "Serial not found";
      const dispositionError = receiveService.getUsBankDispositionError(externalRes)
          || (serialNotFound ? [dispositionResult.disposition, dispositionResult.detail].filter(Boolean).join(". ") : "");
      if (dispositionError) {
        this.$store.commit("ConfigModule/Alert", {
          type: "error",
          isShow: true,
          message: dispositionError,
        });
        if (this.dispositionCallCount >= 2) {
          this.onClickRouteDiscrepancyFunction();
        } else {
          this.serialNum = "";
          this.focusField = "serialNum";
          this.$nextTick(() => {
            this.$refs.serialForm?.resetValidation();
            this.$refs.serialNumberField?.focus();
          });
        }
        return;
      }
      if (!dispositionResult) {
        this.$store.commit("ConfigModule/Alert", {
          type: "error",
          isShow: true,
          message: "Unable to parse the disposition response.",
        });
        return;
      }
      this.dispositionResponse = dispositionResult;
      if (["Not tracked", "Not Tracked", "Re-ship"].includes(dispositionResult.disposition)) {
        EncryptUtility.localStorageEncrypt("receiveDisplayAssest", JSON.stringify(this.displayAssetData));
        this.redirectLineDetails();
        return;
      }
      if (dispositionResult.result === "passed" &&
        ["Dispose", "Redeploy", "Lease Return"].includes(dispositionResult.disposition)) {
        await this.scanDispositionAsset(dispositionResult);
      }
    },
    async scanDispositionAsset(disposition) {
      const serialNumber = this.displayAssetData.find(item => item.label === "Serial Number")?.value;
      const externalRes = await receiveService.postUsBankExternalAssetInfo("post", {
        serial_number: serialNumber,
        location: this.lpnObj.stockRoom,
        rescan: !!this.make,
        make: this.make,
        model: this.model,
      }, false);
      this.assetInfoResponse = externalRes ?? null;
      const result = externalRes?.Body?.result;
      if (!result) return;
      this.displayAssetData = [
        { label: "Serial Number", value: serialNumber },
        { label: "Request Number", value: result.reqNum },
        { label: "RITM", value: result.RITM },
        { label: "Request Status", value: result.reqStatus },
        { label: "Serial Number Status", value: result.serialNumberStatus },
        { label: "RLP Status", value: "" },
        { label: "Asset Action", value: result.assetAction?.toUpperCase() },
        { label: "Disposition", value: disposition.disposition },
      ];
      let conditionCheck =
        result?.assetAction === "Invalid Serial Number" ||
        result?.assetAction == "Fail Warehouse";
      if (!conditionCheck) await this.updateAssetApi(result);
      if (conditionCheck) {
        this.failCount++;
      }
      if (result?.assetAction == "Fail Warehouse" || this.failCount > 2) {
        await this.exceptionAPICall(result);
      }
      if(conditionCheck)
      {
        this.serialNum=""
        this.focusField="serialNum";
      }
      if (this.failCount == 2) {
        this.showMake = true;
      }
    },
    async exceptionAPICall(result) {
      let execeptionObj = {
        UserId: this.userId,
        serialno: this.serialNum,
        req_num: result.reqNum,
        ritm: result.RITM,
        assetaction: result.assetAction?.toUpperCase(),
        ware_key: this.lpnObj.stockRoom,
        part_key: this.partId,
        lbl_size: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
        printer_type: EncryptUtility.localStorageDecrypt("primaryName"),
      };
      let resp = await receiveService.postExceptionAPI(
        "post",
        execeptionObj,
        execeptionObj,
        false
      );
      if (resp?.Info.HeaderInfo[0].status == "OK" && this.lableSwitchValue) {
        resp.Info.LabelInfo
          ? PrinterDetails.printLabelDataArray(
              resp.Info.LabelInfo,
              EncryptUtility.localStorageDecrypt("primaryName")
            )
          : ""; 
      }
      
      if(resp?.Info.HeaderInfo[0].status == "OK"){
        this.resetForm()
        utility.showNoDataToast("Serial Number Moved To Exception. Awaiting update from US BANK.")
       }
 
    },
    onUsbDiscrepancySubmitted(receipt) {
      this.resetForm(receipt.allProductsReceived ? "" : receipt.waybill);
    },
    resetForm(waybill = ""){
      this.showMake=false;
      this.failCount=0;
      this.$refs?.serialForm?.resetValidation();
      this.$refs.partSearchForm?.resetValidation()
      this.showSerialData=false;
      this.clearWaybillSearch();
      this.partSearch="";
      this.model="";
      this.serialNum="";
      this.make="";
      this.showAssestData=false;
      this.showPartInfo=false;
      this.displayAssetData = [];
      EncryptUtility.localStorageEncrypt("receiveDisplayAssest", "");
      if (waybill) {
        this.inboundWaybill = waybill;
        this.waybillValidated = true;
        this.focusField = "partSearch";
        EncryptUtility.localStorageEncrypt("receiveUsBankWaybill", waybill);
      }
      this.$nextTick(() => {
        this.$refs.waybillSearchField?.resetValidation();
        const field = waybill ? this.$refs.partNumberSearchField : this.$refs.waybillSearchField;
        field?.focus();
      });
    },
    async updateAssetApi(result) {
      let updateAssetObj = {
        UserId: this.userId,
        serialno: this.serialNum,
        req_num: result.reqNum,
        ritm: result.RITM,
        assetaction: result.assetAction?.toUpperCase(),
      };
      let res = await receiveService.postUpdateAsset("post", updateAssetObj);
      if (res) {
        const index = this.displayAssetData.findIndex(item => item.label === "RLP Status");
        if (index !== -1) {
      this.displayAssetData[index].value = (typeof res === "string" ? JSON.parse(res) : res).Message;
  }
        EncryptUtility.localStorageEncrypt(
          "receiveDisplayAssest",
          JSON.stringify(this.displayAssetData)
        );
      }
      this.redirectLineDetails();
    },

    onClickReceiveStagingFunction() {
      this.$router.push(`/receiving/${this.receiveType}`);
    },
    onClickReceiveLPNFunction() {
      this.showChangeLpn = true;
      this.dialogType = "LPN";
    },
    receiveQuickVerificationFunction() {
      this.showChangeLpn = true;
      this.dialogType = "Verify";
    },
    closeChangeLpnDialog(lpn) {
      if (lpn) {
        this.showLpnVal = lpn;
        this.lpnObj.lpn = lpn;
        EncryptUtility.localStorageEncrypt(
          "receivelpnDetails",
          JSON.stringify(this.lpnObj)
        );
      }
      this.showChangeLpn = false;
    },
    onClickReceiveResetFunction() {
      this.showDialog = true;
      this.message = `Are you sure you want to close this receipt? You will lose any unsubmitted data`;
    },
    onClickDialogOk() {
      this.showDialog = false;
      this.$router.push(`/receiving`);
    },
    onClickDialogCancel() {
      this.showDialog = false;
    },
    closeDiscrepancyDialog() {
      this.showDiscrepancyDialog = false;
    },
    onClickRouteDiscrepancyFunction() {
      this.showDiscrepancyDialog = true;
    },
    onClickClear() {
      this.$refs.partSearchForm?.resetValidation()
      this.clearWaybillSearch();
      this.activeField = null;
      (this.poObj = {
        UserId: this.userId,
        DiscrepancyTag: "",
        ProjKey: "",
        PartNum: "",
        Vendor: "",
        show_closed: "",
        PageNumber: 1,
      }),
        (this.soObj = {
          UserId: this.userId,
          ProjKey: "",
          RITM: "",
          RequestNumber: "",
          SerialNo: "",
          Waybill: "",
          show_closed: "",
          PageNumber: 1,
          DiscrepancyTag: "",
        });
    },
    redirectLineDetails() {
      usbReceiptState.returnPath = this.$route.path;
      EncryptUtility.localStorageEncrypt("receiveUsBankWaybill", this.inboundWaybill);
      EncryptUtility.localStorageEncrypt("receiveUsBankApiResults", JSON.stringify({
        disposition: this.dispositionResponse,
        assetInfo: this.assetInfoResponse,
      }));
      this.$router.push("/receiving-details-lineitems-usbank");
    },
    clearPartSearch() {
      this.stopAssetStatusPolling();
      usbReceiptState.reset();
      this.dispositionCallCount = 0;
      this.dispositionResponse = null;
      this.assetInfoResponse = null;
      this.showAssestData = false;
      EncryptUtility.localStorageEncrypt("receiveUsBankApiResults", "");
      this.showPartDDL = false;
      this.showPartInfo = false;
      this.partList = [];
      this.partSearch = "";
      this.partInfo = "";
      this.partDesc = "";
      this.partId = 0;
      this.showSerialData = false;
    },
    submit() {
      // Prevent default form submission.
    },
  },
  components: {
    breadcrumbComp,
    FilterComp,
    DisplayTextData,
    ReadOnlyDialog,
    ChangeLpn,
    CommonDialog,
    RouteDiscrepancyComp,
    PrinterDetails,
    UsbAssetResults,
  },
};
